module.exports = __webpack_public_path__ + "static/media/magnifying-glass.62432d67.svg";